import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAdminExpenses,
  getAdminExpenseCategories,
  getAdminLastPayeeByCategory,
  createAdminExpense,
  updateAdminExpense,
  deleteAdminExpense,
} from "../../api/admin/academyExpense.api";

export const fetchExpenses = createAsyncThunk(
  "admin/expenses/fetch",
  async (
    { 
      page = 1, 
      limit = 10, 
      search = "", 
      expense_category_id = "", 
      academy_branch_id = "", 
      status = "", 
      payment_method = "", 
      start_date = "", 
      end_date = "" 
    }, 
    { rejectWithValue }
  ) => {
    try {
      const res = await getAdminExpenses({
        page,
        limit,
        search,
        expense_category_id,
        academy_branch_id,
        status,
        payment_method,
        start_date,
        end_date,
      });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);

export const fetchExpenseCategories = createAsyncThunk(
  "admin/expenses/fetchCategories",
  async (status = "active", { rejectWithValue }) => {
    try {
      const res = await getAdminExpenseCategories(status);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);

export const fetchLastPayeeByCategory = createAsyncThunk(
  "admin/expenses/fetchLastPayee",
  async (expenseCategoryId, { rejectWithValue }) => {
    try {
      const res = await getAdminLastPayeeByCategory(expenseCategoryId);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);

export const addExpense = createAsyncThunk(
  "admin/expenses/add",
  async (payload, { rejectWithValue }) => {
    try {
      // Fully supports FormData containing text fields, numbers, and binary file streams (bill_file)
      const res = await createAdminExpense(payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);

export const updateExpense = createAsyncThunk(
  "admin/expenses/update",
  async ({ id, expenseData }, { rejectWithValue }) => {
    try {
      // Fully supports FormData containing updated text fields, numbers, and new/replacement binary file streams (bill_file)
      const res = await updateAdminExpense(id, expenseData);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);

export const deleteExpense = createAsyncThunk(
  "admin/expenses/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteAdminExpense(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return { id };
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);